import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

interface Permission {
    readonly permission: string;
    readonly action: string;
}

export const permissionsAdapter = createEntityAdapter({
    selectId: (perm: Permission) => `${perm.permission}.${perm.action}` as string,
});

export const permissionsSlice = createSlice({
    name: 'permissions',
    initialState: permissionsAdapter.getInitialState(),
    reducers: {
        setPermissions: permissionsAdapter.setAll,
    },
});

export const { setPermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;